import * as types from '../actions/types';

const INITIAL_STATE = {
  message: '',
  open: false,
  type: '', // error or success
};

const snackbarReducer = (state = INITIAL_STATE, { payload, type, error }) => {
  // store cities used in signup
  switch (type) {
    case types.OPEN_SNACK:
      return {
        message: payload.message,
        type: payload.type,
        open: true,
      };
    case types.CLOSE_SNACK:
      return {
        message: '',
        type: '',
        open: false,
      };

    default:
      return { ...state };
  }
};

export default snackbarReducer;
